// extracted by mini-css-extract-plugin
export default {"main":"App_main__JKHl2","bg":"App_bg__ArNJF","fade":"App_fade__A5uao"};